import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke081aRequest, Sgke081aResponse, Sgke081aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke081aService {

  /**
   * コンストラクタ
   * @param {Sgke081aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke081aService
   */
  constructor(public service: Sgke081aService, public apiCommonService: ApiCommonService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * Sgke081aAPI実行
   *
   * @param {Sgke081aRequest} request
   * @return {*}  {Observable<Sgke081aResponse>}
   * @memberof UsedSgke081aService
   */
  public doSgke081a(request: Sgke081aRequest): Observable<Sgke081aResponse> {

    return this.service.sgke081aPost(this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE081A');
          return throwError(err.message);
        })
      );
  }

}

